import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { CircleDollarSign, Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const DemoCreatorRewards = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      <div className="mt-12 mb-6">
        <img src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" alt="iSPAI Logo" className="h-16 cursor-pointer" onClick={() => navigate("/engage")} />
      </div>

      <div className="w-full max-w-3xl space-y-6">
        <h1 className="text-2xl font-bold text-center mb-6">2025 Owners Modularization Blueprint (OMB) Modernization</h1>
        <h2 className="text-2xl font-bold text-center mb-6">Solution Bounty Rewards Distribution</h2>

        <Card className="border border-gray-200">
          <CardHeader>
            <h2 className="text-xl font-semibold">CURT Sprint Team Reward - $10,000</h2>
          </CardHeader>
          <CardContent className="space-y-8">
            {/* Composer Section */}
            <div className="border-b pb-6">
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-lg font-medium">Solution Bounty Distribution</h3>
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger>
                      <Info className="h-4 w-4 text-gray-500" />
                    </TooltipTrigger>
                    <TooltipContent>
                      <p>1/3 for Composition, 2/3 for Creation</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>
              <div className="flex items-center justify-between bg-gray-50 p-4 rounded-md">
                <div className="flex items-center gap-2">
                  <CircleDollarSign className="h-5 w-5 text-green-600" />
                  <span className="font-medium">Composer (33%)</span>
                </div>
                <span className="text-green-600 font-medium">$3,300.00</span>
              </div>
            </div>

            {/* Knowledge Team Distribution */}
            <div className="space-y-6">
              <div className="flex items-center gap-2">
                <h3 className="text-lg font-medium">Knowledge Team Distribution</h3>
                <div className="text-sm text-gray-600">Remaining 67% of the Solution Bounty is divided across the Creation Team</div>
              </div>
              
              {/* Curator */}
              <div className="flex items-center justify-between bg-gray-50 p-4 rounded-md">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">Curator (50%)</span>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger>
                          <Info className="h-4 w-4 text-gray-500" />
                        </TooltipTrigger>
                        <TooltipContent>
                          <p>Fractionalized KB Ownership</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                  <div className="text-sm text-gray-600 mt-1">Karen Watson</div>
                </div>
                <span className="text-green-600 font-medium">$3,350.00</span>
              </div>

              {/* Contributor */}
              <div className="flex items-center justify-between bg-gray-50 p-4 rounded-md">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">Contributor (45%)</span>
                  </div>
                  <div className="text-sm text-gray-600 mt-1">Corey Vickers</div>
                </div>
                <span className="text-green-600 font-medium">$3,015.00</span>
              </div>

              {/* Confirmer */}
              <div className="flex items-center justify-between bg-gray-50 p-4 rounded-md">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">Confirmer (5%)</span>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger>
                          <Info className="h-4 w-4 text-gray-500" />
                        </TooltipTrigger>
                        <TooltipContent>
                          <p>Confirmation by Giblet to ensure consistency and enable Human-to-AI alignment</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                  <div className="text-sm text-gray-600 mt-1">Giblet</div>
                </div>
                <span className="text-green-600 font-medium">$335.00</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
};
export default DemoCreatorRewards;